<script setup>
import ArrowSquareOutIcon from '@iconify-vue/ph/arrow-square-out';
import PencilSimpleIcon from '@iconify-vue/ph/pencil-simple';
import PlusIcon from '@iconify-vue/ph/plus';
import LoadingSpinner from '@js/components/LoadingSpinner.vue';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import CollapsibleColumn from '@js/components/collapsibles/CollapsibleColumn.vue';
import CollapsibleContainer from '@js/components/collapsibles/CollapsibleContainer.vue';
import ListGroup from '@js/components/lists/ListGroup.vue';
import ListItem from '@js/components/lists/ListItem.vue';
import { toastError } from '@js/utils/toast';
import { h, onMounted, ref } from 'vue';

const loading = ref(true);

const data = ref({
    documentDefinitions: [],
});

function updateData() {
    loading.value = true;

    axios
        .post(route('front.projectManagement.postDocuments'))
        .then((response) => {
            data.value = response.data;
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            toastError(error);
        });
}

onMounted(() => {
    updateData();
});
</script>

<template>
    <LoadingSpinner v-if="loading" />

    <template v-else>
        <div class="mb-4 flex justify-end">
            <ActionButton
                :href="route('front.projectManagement.document')"
                size="small"
                :left-icon="PlusIcon"
            >
                Ajouter
            </ActionButton>
        </div>

        <CollapsibleColumn>
            <CollapsibleContainer
                v-for="(
                    documentDefinition, documentDefinitionIndex
                ) in data.documentDefinitions"
                :key="documentDefinitionIndex"
                :title="documentDefinition[0]?.group?.label"
            >
                <ListGroup>
                    <ListItem
                        v-for="(document, documentIndex) in documentDefinition"
                        :key="documentIndex"
                        :icon="
                            document.svgIcon
                                ? () =>
                                      h('span', { innerHTML: document.svgIcon })
                                : null
                        "
                        :title="`${document.group.label} ${document.name}`"
                    >
                        <template #actions>
                            <ActionButton
                                :href="
                                    route('front.projectManagement.document', {
                                        document: document.id,
                                    })
                                "
                                :left-icon="PencilSimpleIcon"
                                size="small"
                            >
                                Modifier
                            </ActionButton>

                            <ActionButton
                                :href="document.url"
                                :left-icon="ArrowSquareOutIcon"
                                target="_blank"
                                size="small"
                                type="bordered"
                            >
                                Voir
                            </ActionButton>
                        </template>
                    </ListItem>
                </ListGroup>
            </CollapsibleContainer>
        </CollapsibleColumn>
    </template>
</template>
